import { Plus, Search } from "lucide-react";
import { useLocation } from "wouter";
import { NAV_LABEL, navIcon, openTodayNote, useNav, type NavId } from "./navConfig";
import { newNoteHere } from "./newNote";
import { Account } from "./Sidebar";

const ROUTE: Partial<Record<NavId, string>> = {
  home: "/home",
  shortcuts: "/shortcuts",
  notes: "/notes",
  tasks: "/tasks",
  files: "/files",
  notebooks: "/notebooks",
  trash: "/trash",
};

/** Evernote Android's left navigation rail (the Fold's cover and inner screens); items are customizable (account menu). */
export function Rail({ tagsOpen, onToggleTags, onSignedOut }: { tagsOpen: boolean; onToggleTags: () => void; onSignedOut: () => void }) {
  const [path, navigate] = useLocation();
  const nav = useNav("rail");
  const is = (p: string) => path === p || path.startsWith(p + "/");
  // Evernote's rail puts a gap between the pages and Notebooks/Tags/Trash.
  const lower = (id: NavId) => (id === "notebooks" || id === "tags" || id === "trash" ? 1 : 0);
  return (
    <nav className="rail">
      <Account onSignedOut={onSignedOut} compact />
      <button className="rail-search" title="Search" aria-label="Search" onClick={() => window.dispatchEvent(new Event("engram:search"))}>
        <Search size={20} />
      </button>
      <button className="rail-create" title="New note" aria-label="New note" onClick={() => void newNoteHere(path, navigate)}>
        <Plus size={22} strokeWidth={2.5} />
      </button>
      {nav.map((id, i) => {
        const gap = i > 0 && lower(id) !== lower(nav[i - 1]!) ? <div key={`gap-${id}`} className="rail-gap" /> : null;
        const label = NAV_LABEL[id];
        const btn =
          id === "tags" ? (
            <button key={id} className={`rail-item rail-tags${tagsOpen ? " active" : ""}`} title={label} aria-label={label} onClick={onToggleTags}>
              {navIcon(id, 20)}
            </button>
          ) : id === "today" ? (
            <button key={id} className="rail-item" title={label} aria-label={label} onClick={() => void openTodayNote(navigate)}>
              {navIcon(id, 20)}
            </button>
          ) : (
            <button key={id} className={`rail-item${is(ROUTE[id]!) ? " active" : ""}`} title={label} aria-label={label} onClick={() => navigate(ROUTE[id]!)}>
              {navIcon(id, 20)}
            </button>
          );
        return gap ? [gap, btn] : btn;
      })}
    </nav>
  );
}
